import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, PasswordTextField } from 'src/components';
import { useNavigate } from 'react-router-dom';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {}
const PASSWORD_FORM_VALIDATION = Yup.object().shape({
  oldPassword: Yup.string()
    .matches(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/,
      'Password must be at least one alpha numeric character, 8 character long, at least one numeric and up to.'
    )
    .required('Required'),
  newPassword: Yup.string()
    .matches(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/,
      'Password must be at least one alpha numeric character, 8 character long, at least one numeric and up to.'
    )
    .required('Required'),

  cPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Required'),
});

const PasswordTab: React.FC<IProps> = ({}) => {
  const navigate = useNavigate();

  const passwordInitValues = {
    oldPassword: '',
    newPassword: '',
    cPassword: '',
  };

  const handleChangePassword = async (val: {
    oldPassword: string;
    newPassword: string;
    cPassword: string;
  }) => {
    const payload = {
      oldPassword: val?.oldPassword,
      newPassword: val?.newPassword,
    };

    try {
      await Service.post('employees/changepassword', payload);
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('userInfo');
      navigate('/login');
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <Formik
      initialValues={passwordInitValues}
      validateOnMount
      validationSchema={PASSWORD_FORM_VALIDATION}
      onSubmit={handleChangePassword}
    >
      {({ isSubmitting, isValid }) => (
        <Form>
          <PasswordTextField label="Old password" name="oldPassword" />
          <PasswordTextField label="New Password" name="newPassword" />
          <PasswordTextField label="Confirm Password" name="cPassword" />

          <div className="flex items-center justify-end  mt-6">
            <Button
              text="Change Password"
              variant="primary"
              isSubmitting={isSubmitting}
              isValid={isValid}
              type="submit"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default React.memo(PasswordTab);
